const dimensions = {};
// Speaker units
dimensions.speakers = {};
dimensions.speakers.front = {
  a: { x: 660, y: 1812, w: 825, h: 1150, z: 5 },
  b: { x: 2014, y: 1812, w: 825, h: 1150, z: 6 },
};
dimensions.speakers.side = {
  a: { x: 1114, y: 1600, w: 1275, h: 1275, z: 5 },
  b: { x: 1114, y: 1600, w: 1275, h: 1275, z: 3 },
};

// headband
dimensions.headband = {};
dimensions.headband.front = {
  a: { x: 514, y: 192, w: 2475, h: 2875, z: 1 },
};
dimensions.headband.side = {
  a: { x: 1462, y: 182, w: 575, h: 2775, z: 4 },
};

// earpads
dimensions.earpads = {};
dimensions.earpads.front = {
  a: { x: 780, y: 1598, w: 975, h: 1375, z: 2 },
  b: { x: 1755, y: 1598, w: 975, h: 1375, z: 3 },
};
dimensions.earpads.side = {
  a: { x: 1014, y: 1498, w: 1475, h: 1475, z: 1 },
};

// cable
dimensions.cable = {};
dimensions.cable.front = {
  a: { x: 1190, y: 2633, w: 875, h: 2335, z: 4 },
};
dimensions.cable.side = {
  a: { x: 1615, y: 2527, w: 275, h: 1975, z: 2 },
};

export default dimensions;
